import React, { FC, PropsWithChildren } from "react";
/*import { Close as CloseIcon } from "assets/icons/10x10";*/
import styles from "./Toast.module.scss";

type Props = PropsWithChildren<{
  title?: string;
  onClose?: () => void;
}>;

/* todo: add close on swipe */
const Toast: FC<Props> = ({ title, children, onClose }: Props) => {
  function onCloseHandler() {
    onClose && onClose();
  }

  return (
    <div className={styles.toastContainer} onClick={onCloseHandler}>
      {/*<div className={styles.toastClose} onClick={onCloseHandler}>
        <CloseIcon />
      </div>*/}
      {title && <div className={styles.toastHeader}>{title}</div>}
      {children && <div className={styles.toastContent}>{children}</div>}
    </div>
  );
};

export default Toast;
